export default __webpack_public_path__ + "static/media/Dedicated_teachers.fda38f15.png";